<template>
    <app-data-table
        :fields="fields"
        :items="tableData"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="created_at" slot-scope="{ item }">
            {{ item.created_at | datetime }}
        </template>

        <template slot="actions" slot-scope="{ item }">
            <b-button  size="sm" variant="primary" @click="seeCard(item)"><i class="fa fa-search-plus"></i> Ver encuesta</b-button>
            <b-button  size="sm" variant="danger" @click="removePoll(item)"><i class="fa fa-trash"></i></b-button>
        </template>
    </app-data-table>
</template>
<script>

export default {
    props: {
        data: {
            type: Object
        }
    },
    data(){
        return {
            fields: [
                {
                    key: 'created_at',
                    label: 'Fecha creación',
                    filter: true
                },
                {
                    key: 'satisfaction_poll_mode.name',
                    label: 'Modalidad',
                    filter: true
                },
                {
                    key: 'answered_by',
                    label: 'Encuestado',
                    filter: true
                },
                {
                    key: 'contact_report.id',
                    label: 'Reunión',
                    filter: true
                },
                {
                    key: 'actions',
                    label: 'Acciones'
                }
            ]
        }
    },
    computed: {
        tableData(){
            if(!this.data || !this.data.data) return [];

            return this.data.data.map(item => ({...item}));
        }
    },
    methods: {
        onChangePage(page){
            this.$emit('change-page', page);
        },
        removePoll(data){
            this.$emit('remove-poll', data);
        },
        seeCard(data){
            this.$emit('see-card', data);
        },
        onSort(ctx) {
            this.$emit('sort', ctx);
        },
    }
}
</script>